import { Seo } from "@/components/Seo";
import { Reveal } from "@/components/Reveal";
import { PageHeader } from "@/components/PageHeader";
import { BtnLink } from "@/components/BtnLink";
import { useT } from "@/context/LanguageContext";

const IMG = "https://images.unsplash.com/photo-1560612137-e423867d48d4?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";

export default function About() {
  const t = useT().about;
  return (
    <>
      <Seo title="À propos" description="Riviera Host Collection associe hospitalité, technologie, optimisation commerciale et présence humaine." path="/a-propos" />
      <PageHeader overline={t.overline} title={t.title} />
      <section className="py-20 sm:py-28 max-w-[1500px] mx-auto px-5 sm:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-start">
          <Reveal>
            <p className="font-serif text-3xl sm:text-4xl lg:text-5xl leading-[1.15]">{t.lead.map((line, i) => <span key={i} className="block">{line}{" "}</span>)}</p>
            <p className="mt-10 text-ink/75 leading-[1.85] max-w-xl">{t.p1}</p>
            <p className="mt-7 text-ink/75 leading-[1.85] max-w-xl">{t.p2}</p>
            <p className="mt-7 text-ink/75 leading-[1.85] max-w-xl">{t.p3}</p>
            <p className="mt-7 text-ink/75 leading-[1.85] max-w-xl">{t.p4}</p>
            <div className="mt-12"><BtnLink to="/proprietaires" variant="outline" data-testid="about-cta">{t.cta}</BtnLink></div>
          </Reveal>
          <Reveal delay={0.1}><div className="img-zoom aspect-[4/5]"><img src={IMG} alt="La Côte d’Azur, territoire de Riviera Host Collection" loading="lazy" className="w-full h-full object-cover" /></div></Reveal>
        </div>
      </section>
    </>
  );
}
